export enum ShapeMode {
  Rectangle,
  Circle,
  Polygon
}
